import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Errors, actions } from 'react-redux-form';
import { Button } from "react-bootstrap";
import { inventoryCircuitActions } from "../../../../store/external/inventory/circuit.reducer";
import Translation from "../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import {
    SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField,
    SelectFieldFloatingLabel_Ranking as SelectRanking
} from "../../../common/custom-form/select-filter.component";
import DateRange from "../../../common/custom-form/custom-date-range-component";
import DATEPICKER_OR from "../../../common/custom-form/custom-date-picker.component";
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { ListTabButton } from "../../../common/list-tab/list-tab-button.component";
import "./inventory-details.view.component.css"
import AddPlanDetails from "./add-plan-details.component";
import { addPlanDetailActions } from "../../../../store/external/inventory/details-view/add-plan-details.reducer";
import AddSim from "./add-sim/add-sim.component";
import AddEquipment from "./add-equipment/add-equipment.component";
import AddCostAllocation from "./add-cost-allocation.component";
import ButtonIcon from "../../../button";
import { accessInformationActions } from "../../../../store/external/inventory/details-view/access-information.reducer";
import { pipInformationActions } from "../../../../store/external/inventory/details-view/pip-information.reducer";
import Icon from "../../../icon";
import { ACTION_TYPES, RAISE_REQUEST_LINKS, WIRELESS_REQUEST_TYPES_ID, Selected_Index, CIRCUIT_SIM_RANK, CIRCUIT_CATEGORIES, MAX_LENGTH, DATA_TYPE, WIRELINE_REQUEST_TYPES_ID, REQUEST_STATUS, ROUTE_LINK_LOCATION } from "../../../../constants/external-constants";
import { CircuitNotification } from "../modal/circuit-notification-modal.component";
import DetailsHistory from "../history/items/details-history.component";
import { withRouter } from 'react-router-dom';
import UsageSpend from "../usagespend/usagespend-component";
import { CIRCUIT_STATUS } from "../../../../utils/constant.utils";
import { areDataEqual, isObjectEqual, valueExist } from '../../../../utils/helpers.utils';
import { createRequestActions } from "../../../../store/external/request-reducer/create-request.reducer";
import { circuitUsageActions } from "../../../../store/external/circuit-usage-reducer/circuit-usage.reducer";
import { sideNavMenuActions } from '../../../../store/external/side-nav-menu-reducer/side-nav-menu.reducer';
import LinkedCircuit from "../linked-circuits/linked-circuits.component";
import { inventoryCostAllocationActions } from "../../../../store/external/inventory/add-cost-allocation.reducer";
import UserDetailsInfo from '../modal/user-details-modal';
import CustomSearchableSelectWrapper from "../../../common/custom-form/custom-searchable-select-wrapper.component";
import { AddressDetails } from "./add-address.component";
import InvoiceCircuit from "../invoice/invoice.component";
import { ConfirmationModal } from "../../../common/modal/modal.component";
import { NotificationModal } from "../../../common/modal/notification-modal.component";
import CircuitComment from "../circuit-comments/circuit-comments.component";
import { inventoryOrderHistoryActions } from "../../../../store/external/inventory/history/order-history.reducer"
import { inventoryCircuitEquipActions } from "../../../../store/external/reports-reducer/inventory/details-view/add-equipment.reducer";
import { inventoryCircuitSimActions } from "../../../../store/external/inventory/details-view/add-sim.reducer";
import DetailsInfo from "../../../common/modal/details-modal/details-info";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";

class InventoryDetails extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            circuitId: this.props.circuitId,
            selectedCircuit: this.props.selectedCircuit,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            addCostChange: false,
            isSaving: false,
            isTogglePlan: false,
            isOriginalComponent: false,
            proceedSaveModal: false,
            inputValue: "",
            installDate: "",
            selectedIndex: "0",
            showTakeActionModal: false,
            showTakeAction: false,
            showCostAllocationDetails: false,
            simChange: false,
            equipmentChange:false,
            planDetailsChange:false,
            planDetailsUpdated: false,
            pendingApproval: false,
            modalType: '',
            showConfModal: true,
            activeDropdown: null,
            orderHistorySelected: false,
            isInService: false,
            loading: true,
            inProgress: true,
            planId: 0,
            mrcValue: "0.00",
            fileList: [],
            dropDownFields:{
                circuitTypeID: null,
                subCircuitTypeID: null,
                linkedCircuitID: null,
                billingAccountID: null
            },
            takeActionItem: [],
            listTabInfo: {
                Tab: [
                    {
                        "id": Selected_Index.i_Zero,
                        "label": "Details",
                        "hidden": false
                    },
                    {
                        "id": Selected_Index.i_One,
                        "label": "Usage Spend",
                        "hidden": false,
                        "disable": true
                    },
                    {
                        "id": Selected_Index.i_Two,
                        "label": "Linked Circuits",
                        "hidden": false
                    },
                    {
                        "id": Selected_Index.i_Three,
                        "label": "Invoice",
                        "hidden": false,
                        "disable": true
                    },                    
                    {
                        "id": Selected_Index.i_Four,
                        "label": "Comments",
                        "hidden": false,
                        "disable": true
                    },
                    {
                        "id": Selected_Index.i_Five,
                        "label": "History",
                        "hidden": false,
                        "disable": true
                    }
                ]
            },
            historyTabInfo: {
                Tab: [
                    {
                        "id": "0",
                        "label": "Circuit History"
                    },
                    {
                        "id": "1",
                        "label": "Order History"
                    }
                ]
            },
            pages: {
                "PageNumber": 0,
                "PerPage": 10,
                "TotalPages": 2,
                "TotalEntries": 11,
                "HasNext": true,
                "HasPrevious": false,
                "PageSizes": [
                    10,
                    20,
                    30
                ]
            },
            originalVendorID: 0,
            originalCircuitTypeID: 0,
            originalPlanDetails: {
                "datatable": []
            },
            updateEquipmentListStatus: false,
            originalData: {} ,
            originalSimData: {},
            originalPlanData: {},
            originalEquipmentData: {},
            originalCostAllocationData: {},
        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    FilterIndex(tabIndex) {
        this.setState({ selectedIndex: tabIndex });

    }

    CloseForm() {
        this.props.closeForm(false)
    }

    ShowCostAllocationDetails(value) {
        this.setState({ showCostAllocationDetails: value })
    }
    handleTakeActionModal(modalType) {
        this.setState({ showTakeActionModal: true, modalType });
    };

    handleShowTakeAction() {
        this.setState({ showTakeAction: !this.state.showTakeAction }, () => {
            if (this.state.showTakeAction) {
                document.addEventListener('click', this.handleOutsideClick);
            } else {
                document.removeEventListener('click', this.handleOutsideClick);
            }
        })
    }

    handleOutsideClick(e) {
        if (e.target.closest('.create-request-children') || e.target.closest('.icon-nav')) {
            return;
        }
        this.setState({ showTakeAction: false });
        document.removeEventListener('click', this.handleOutsideClick);
    };

    handleConfirmationModal = () => {
        this.setState(prevState => ({ showConfModal: !prevState.showConfModal }));
    }

    handelToggleDropdown = (index, isShow = false) => {
        this.setState(prevState => ({
            activeDropdown: prevState.activeDropdown === index && !isShow ? null : index
        }));
    }

    handleTakeActionModal = (id, type) => {
        this.props.setRequestType(id, type);
        this.props.setTakeActionCircuitCode(this.state.selectedCircuit);
        this.props.setTakeActionSubScriptionDetail(this.state.selectedCircuit);
        this.props.history.push("Circuit/" + RAISE_REQUEST_LINKS.orderRequest.link + id);
    }

    handelOrderHistorySelected(id, type) {
        this.props.history.push("History/MyRequest/RequestDetail/Order/" + id);
    }

    async componentDidMount() {       
        window.scrollTo(0, 0);
        this.props.getInventoryAllDropdownList();
        this.props.getInventoryCircuitTypesByCategory(CIRCUIT_CATEGORIES.mobile);
        this.fetchData(this.state.circuitId, this.state.selectedCircuit);

        await this.props.getInventoryOrderHistory(this.state.circuitId);
        this.orderHistoryStatus();

        if (this.state.selectedCircuit !== null && this.state.selectedCircuit !== undefined) {
            if (this.state.selectedCircuit.CircuitTypeID > 0 && this.state.selectedCircuit.AccountID > 0) {
                this.props.GetlinkCircuitsByBillingAccountIdAndCircuitTypeId(this.state.circuitId, this.state.selectedCircuit.CircuitTypeID, this.state.selectedCircuit.AccountID)
            }
        }
    }
  
    async componentWillUnmount() {
        this.props.resetInventoryCircuitForm();
        this.props.clearSelectedUser();
    }

    componentDidUpdate(prevProps) {
        if(this.props.inventoryCircuitForm.circuitDetails.monthlyRateCharge !== prevProps.inventoryCircuitForm.circuitDetails.monthlyRateCharge) {
            this.setState({
                mrcValue: this.props.inventoryCircuitForm.circuitDetails.monthlyRateCharge
            });
        }

        if (parseInt(this.state.originalCircuitTypeID) === 0
            && parseInt(this.props.inventoryCircuitForm.circuitDetails.circuitTypeID) !== parseInt(prevProps.inventoryCircuitForm.circuitDetails.circuitTypeID))
        {
            this.setState({
                originalCircuitTypeID: this.props.inventoryCircuitForm.circuitDetails.circuitTypeID
            });

        }
        if (parseInt(this.state.originalVendorID) === 0
            && parseInt(this.props.inventoryCircuitForm.circuitDetails.vendorID) !== parseInt(prevProps.inventoryCircuitForm.circuitDetails.vendorID))
        {
            this.setState({
                originalVendorID: this.props.inventoryCircuitForm.circuitDetails.vendorID
            });
        }

        if (this.state.originalPlanDetails.datatable.length === 0
            && this.props.inventoryCircuitPlanDetails.planDetails.datatable.length > 0)
        {
            this.setState({
                originalPlanDetails: {
                    "datatable": this.props.inventoryCircuitPlanDetails.planDetails.datatable
                }
            });
        }
    }

    async fetchData(circuitId, selectedCircuit) {
        const isInService = selectedCircuit
            && parseInt(selectedCircuit?.CircuitStatusID) === parseInt(CIRCUIT_STATUS.inService.id);
        await this.props.fetchCreateRequestItems(isInService);

        const isWireless = valueExist(WIRELESS_REQUEST_TYPES_ID, selectedCircuit?.CircuitTypeID);
        const isWireline = valueExist(WIRELINE_REQUEST_TYPES_ID, selectedCircuit?.CircuitTypeID);
        const wireless = this.props.requestTypes && this.props.requestTypes.Wireless ? this.props.requestTypes.Wireless.ActionsAndRequests : [];
        const wireline = this.props.requestTypes && this.props.requestTypes.Wireline ? this.props.requestTypes.Wireline.ActionsAndRequests : [];

        let takeActionItem = [];
        if (isWireless) takeActionItem = wireless;
        else if (isWireline) takeActionItem = wireline;

        this.setState({
            isInService: isInService,
            takeActionItem: takeActionItem
        });
        window.scrollTo(0, 0);
        //<!-- Add Cost Allocation
       await this.props.getAddCostAllocation(circuitId).then(()=>{
            const originalCostAlloDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCostAllocation));
            this.setState({ originalCostAllocationData: originalCostAlloDataCopy })
        });
        this.props.getEquipmentDetailsList(circuitId);
        this.props.getInventoryAllSubCircuitTypes(circuitId);

        //<-- Access/PIP Information
        this.props.getCircuitAccessInformationDetails(circuitId);
        this.props.getCircuitPIPInformationDetails(circuitId);

        //<!-- Add Sim Details
          await this.props.getCircuitSimList(circuitId).then(()=>{
            const originalSimDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitSIM));
            this.setState({  originalSimData: originalSimDataCopy })
        })
      
        //<!-- Add Equipment
        await this.props.getCircuitEquipList(circuitId, selectedCircuit?.VendorID ?? 0).then(()=>{
            const originalEquipmentDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitEquip));
            this.setState({ originalEquipmentData: originalEquipmentDataCopy })
        })
        //<-- Add Plan Details
        await this.props.getInventoryCircuitPlanDetails(circuitId).then(()=>{
            const originalPlanDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitPlanDetails));
            this.setState({ originalPlanData: originalPlanDataCopy })
        });
        if (circuitId) {
            const { planDetails } = this.props.inventoryCircuitPlanDetails;
            const planId = planDetails?.datatable[0]?.dataItem[0]?.PlanId ?? 0;

            this.props.getInventoryCircuitPlanComponents(planId, true);

            this.setState({ planId: planId, isOriginalComponent: true });
        }
        await this.props.getInventoryPlanTypesByVendorByCircuitType(this.props.inventoryCircuitForm.circuitDetails.vendorID ?? 0, this.props.inventoryCircuitForm.circuitDetails.circuitTypeID ?? 0);
        //<!-- Add Plan Details       
        await this.props.getInventoryCircuitCostCenterList().then(() => {
            const originalCircuitDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitForm));
            this.setState({loading: false, inProgress: false, originalData: originalCircuitDataCopy});
        });
        
        let data = JSON.parse(sessionStorage.User).Employee;
        this.props.clearCircuitData();
        if (parseInt(selectedCircuit?.EmployeeID) !== parseInt(data.EmployeeId)) {
            this.props.setSelectedUser(
                {
                    EmployeeId: selectedCircuit?.EmployeeID,
                    FullName: selectedCircuit?.UserFullName,
                    EId: selectedCircuit?.Eid,
                    EmailAddress: selectedCircuit?.UserEmailAdd,
                    ContactNumber: selectedCircuit?.UserContactNumber,
                    Country: selectedCircuit?.UserLocationCountry,
                    Location: selectedCircuit?.UserLocationName,
                    LocationSiteCityCountry: `${selectedCircuit?.UserLocationSite} - ${selectedCircuit?.UserLocationCity}, ${selectedCircuit?.UserLocationCountry}`,
                    Vip: selectedCircuit?.UserVIP,
                }
            );
        }
        await this.props.fetchCircuitData(circuitId, selectedCircuit !== undefined ? selectedCircuit.AccountID : 0);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    onChangeDates = (dates) => {
        const [start, end] = dates;

        this.props.selectDate('inventoryCircuitForm.circuitDetails.suspensionFromDate', start);
        this.props.selectDate('inventoryCircuitForm.circuitDetails.suspensionToDate', end);
    };
    transformOptions = (option) =>{
        // use to transform data structure aligned to custom select dropdown
        let newOption;
        newOption = option?.map(elem => {
            return {
                FilterId: elem.Key || elem.BillingAccountID,
                FilterName: elem.Value || elem.BillingAccount,
                FilterValue: elem.Value || elem.BillingAccount,
            }
        })
        return newOption;
    }
    searchValue = (key, listItem) => {
        if (!key || !listItem || listItem.length <= 0) {
            return;
          }
        
        let result;
        const getValue = listItem?.filter(item => item.Key === key || item.BillingAccountID === key || item.PlanId)
        if(getValue?.length > 0){
            
            const [{Value, BillingAccount, PlanName }] = getValue;
            result = Value || BillingAccount || PlanName;
        }

        return result;
    }
    handleSelectDropdownChange = (props) =>{
           
            this.setState(prevState => ({dropDownFields:{
                ...prevState.dropDownFields,
                [props.target?.tagName]: props.key}
            }));
        
    }

    activeListTabInfo = () => {
        const { Tab } = this.state.listTabInfo;
        const { inventoryCircuitForm } = this.props;
        const { selectedCircuit } = this.state;

        var listTab = Tab.map((item) => {
            if (parseInt(item.id) === parseInt(Selected_Index.i_Two) && !this.props.createNew) {
                return {
                    ...item,
                    hidden: selectedCircuit?.PrimarySecondary !== CIRCUIT_SIM_RANK.Primary
                }
            }
            else if ((parseInt(item.id) === parseInt(Selected_Index.i_One) || parseInt(item.id) === parseInt(Selected_Index.i_Three) || parseInt(item.id) === parseInt(Selected_Index.i_Four) || parseInt(item.id) === parseInt(Selected_Index.i_Five)) && (inventoryCircuitForm.circuitDetails && inventoryCircuitForm.circuitDetails.circuitID > 0)) {
                return {
                    ...item,
                    disable: false
                };
            }
            return item;
        });

        return listTab;
    }
    onChangeCircuitTypeSelection(newCircuitType) {
        const { inventoryCircuitForm } = this.props;
        const { circuitDetails } = inventoryCircuitForm;
        const { vendorID, circuitTypeID, billingAccountID } = circuitDetails;

        if (parseInt(newCircuitType) !== parseInt(circuitTypeID)) {
            this.props.selectCircuitTypeID();
            this.setState({ isTogglePlan: !this.state.isTogglePlan, isOriginalComponent: false });

            const vendorToUse = vendorID || 0;
            this.props.getInventoryPlanTypesByVendorByCircuitType(vendorToUse, newCircuitType);

            if (parseInt(this.state.circuitId) === 0) {
                this.props.deletePlanDetails();
                this.props.getInventoryCircuitPlanComponents();
            }

            const isOriginalCircuitTypeOrVendorChanged =
                parseInt(this.state.originalCircuitTypeID) !== parseInt(newCircuitType) ||
                parseInt(this.state.originalVendorID) !== parseInt(vendorID);

            if (isOriginalCircuitTypeOrVendorChanged && this.state.circuitId > 0 && this.hasPlanDetails()) {
                this.props.deletePlanDetails();
                this.props.getInventoryCircuitPlanComponents();
            }

            const isOriginalCircuitTypeAndVendorMatch =
                parseInt(this.state.originalCircuitTypeID) === parseInt(newCircuitType) &&
                parseInt(this.state.originalVendorID) === parseInt(vendorID);

            if (isOriginalCircuitTypeAndVendorMatch && this.state.circuitId > 0 && this.hasOriginalPlanDetails()) {
                this.setState({ isOriginalComponent: true });
                this.props.getInventoryCircuitPlanComponents(this.state.planId, true);
                this.props.inventoryCircuitPlanDetails.planDetails.datatable = this.state.originalPlanDetails.datatable;
            }

            if (billingAccountID > 0) {
                this.props.GetlinkCircuitsByBillingAccountIdAndCircuitTypeId(this.state.circuitId, newCircuitType, billingAccountID);
            }
        }
    }

    onChangeBillingAccountSelection(newBillingAccount) {
        const { inventoryCircuitForm, selectBillingAccountID, inventoryCircuit, resetBillingAccount } = this.props;
        const { circuitDetails } = inventoryCircuitForm;
        const { circuitTypeID, vendorID, billingAccountID } = circuitDetails;

        if (parseInt(newBillingAccount) !== parseInt(billingAccountID)) {
            selectBillingAccountID(newBillingAccount);

            const matchingBilling = inventoryCircuit.inventoryAllAccountDetails.find(r => r.BillingAccountID === newBillingAccount);
            const newVendorID = matchingBilling ? matchingBilling.VendorDetailID : 0;

            this.props.getInventoryPlanTypesByVendorByCircuitType(newVendorID || 0, circuitTypeID || 0);

            if (parseInt(this.state.circuitId) === 0 && parseInt(vendorID) !== parseInt(newVendorID)) {
                this.resetPlanDetails();
            }

            const isOriginalCircuitTypeOrVendorChanged =
                parseInt(this.state.originalCircuitTypeID) !== parseInt(circuitTypeID) ||
                parseInt(this.state.originalVendorID) !== parseInt(newVendorID);

            if (isOriginalCircuitTypeOrVendorChanged && this.state.circuitId > 0 && this.hasPlanDetails()) {
                if (parseInt(vendorID) !== parseInt(newVendorID)) {
                    this.resetPlanDetails();
                }
            }

            const isOriginalCircuitTypeAndVendorMatch =
                parseInt(this.state.originalCircuitTypeID) === parseInt(circuitTypeID) &&
                parseInt(this.state.originalVendorID) === parseInt(newVendorID);

            if (isOriginalCircuitTypeAndVendorMatch && this.state.circuitId > 0 && this.hasOriginalPlanDetails()) {
                if (parseInt(vendorID) !== parseInt(newVendorID)) {
                    this.setState({ isTogglePlan: !this.state.isTogglePlan, isOriginalComponent: true });
                    this.props.getInventoryCircuitPlanComponents(this.state.planId, true);
                    this.props.inventoryCircuitPlanDetails.planDetails.datatable = this.state.originalPlanDetails.datatable;
                }
            }

            if (parseInt(newBillingAccount) !== parseInt(billingAccountID) || parseInt(this.state.originalCircuitTypeID) !== parseInt(circuitTypeID)) {
                this.props.GetlinkCircuitsByBillingAccountIdAndCircuitTypeId(this.state.circuitId, circuitTypeID, newBillingAccount);
            }
        }

        if (newBillingAccount === "") {
            resetBillingAccount();
        }
    }

    hasPlanDetails() {
        return this.props.inventoryCircuitPlanDetails.planDetails.datatable.length > 0;
    }

    hasOriginalPlanDetails() {
        return this.state.originalPlanDetails.datatable.length > 0;
    }

    resetPlanDetails() {
        this.setState({ isTogglePlan: !this.state.isTogglePlan, isOriginalComponent: false });
        this.props.deletePlanDetails();
        this.props.getInventoryCircuitPlanComponents();
    }

    onChangeLocationSiteSelect = (circuitKey, updateFunction, indicator, item) =>{
        const { inventoryCircuit, inventoryCircuitFormA } = this.props;

        if (item !== inventoryCircuitFormA.location1Id) {
            var circuitLocation = JSON.parse(JSON.stringify(inventoryCircuit[circuitKey]));
            var addressOptions = inventoryCircuit.inventoryAllLocations;
            var newCircuitLocation = addressOptions.length > 0 ? addressOptions.find(r => r.LocationId === item) : '';
        }
        circuitLocation.locationSiteId = item;
        circuitLocation.address1 = newCircuitLocation.LocationAddress1;
        circuitLocation.address2 = newCircuitLocation.LocationAddress2;
        circuitLocation.locationType = newCircuitLocation.LocationType;
        circuitLocation.locationCity = newCircuitLocation.LocationCity;
        circuitLocation.locationState = newCircuitLocation.LocationState;
        circuitLocation.locationCountry = newCircuitLocation.CountryName;
        circuitLocation.locationZip = newCircuitLocation.LocationZip;
        circuitLocation.demarcLocation = inventoryCircuit[circuitKey].demarcLocation;
    
        this.setState({
            [circuitKey]: circuitLocation,
            location1Id: newCircuitLocation.LocationId
        });
    
        updateFunction(circuitLocation, item)
    }    

    handleOnBlurMrc = (model) => {
        let newValue = this.state.mrcValue;       
        if (newValue !== '' && /^\d+$/.test(newValue)) {
            newValue += ".00";
        }        
        else if(newValue === '') {
            newValue = "0.00";
        }       
        this.setState({mrcValue: newValue});
        this.props.FormChange(model, newValue === '' ? "0.00" : newValue);
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    handleSaveCircuitDetails = async (confirmSavePropName = null, validate = 1) => {
        const { saveCircuitDetails, circuitId, inventoryCircuitForm, inventoryCircuitEquip, $form } = this.props;
        const { planDetailsUpdated } = this.state;

        await this.props.getInventoryOrderHistory(this.state.circuitId);
        this.orderHistoryStatus();

        if (!this.state.pendingApproval) {
            if (parseInt($form.loadedValue?.circuitDetails.statusID) === parseInt(CIRCUIT_STATUS.inService.id) && parseInt(inventoryCircuitForm.circuitDetails.statusID) !== parseInt(CIRCUIT_STATUS.inService.id)
                && inventoryCircuitEquip.circuitEquipList.datatable.length > 0
                && inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem.length > 0
                && this.state.updateEquipmentListStatus === true)
            {
                inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem.forEach(this.updateEquipmentListStatus);
            } else {
                this.setState({
                    updateEquipmentListStatus: false
                });
            }

            this.setState({
                isSaving: true
            })

            var result = await saveCircuitDetails(circuitId, confirmSavePropName, validate, planDetailsUpdated);

            this.setState({
                isSaving: false
            });

            if (result.success === false) {
                let confirmAction;
                if (result.confirmProceed) {
                    confirmAction = () => this.handleSaveCircuitDetails(result.propertyName, 0);
                    this.toggleSaveModal(true, this.toLocaleLanguage("modal_error_title"), result.message, confirmAction);
                    return;
                }          
                else if (result.isValid) {
                    const isNew = this.state.circuitId === 0;
                    if (isNew === false) {

                        if (parseInt($form.loadedValue?.circuitDetails.statusID) === parseInt(CIRCUIT_STATUS.inService.id) && parseInt(inventoryCircuitForm.circuitDetails.statusID) !== parseInt(CIRCUIT_STATUS.inService.id)) {

                            if (inventoryCircuitEquip.circuitEquipList.datatable.length > 0
                                && inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem.length > 0)
                            {
                                this.setState({
                                    updateEquipmentListStatus: true
                                });
                            }

                            const confirmMessage = this.toLocaleLanguage("save_circuit_updatingStatus_confirmation");
                            const modalTitle = this.toLocaleLanguage("update");
                            confirmAction = () => this.handleSaveCircuitDetails(null, 0);
                            this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                            return;
                        } else {
                            const confirmMessage = this.toLocaleLanguage("save_confirmation");
                            const modalTitle = this.toLocaleLanguage("call_save");
                            confirmAction = () => this.handleSaveCircuitDetails(null, 0);
                            this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                            return;
                        } 
                    }
                    else {
                        this.handleSaveCircuitDetails(null, 0);
                        return;
                    }
                }
                else {
                    this.toggleSaveModal(false);
                    this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title"), result.message);
                    return;
                }
            }
            else if (result.success === true) {
                var isNewCircuit = circuitId === 0;
                const successMessage = isNewCircuit ? this.toLocaleLanguage("new_circuit_message") : this.toLocaleLanguage("update_circuit_message");

                if (isNewCircuit) {
                    const circuitDetails = result.circuitDetails;
                    this.setState({
                        selectedCircuit: circuitDetails,
                        circuitId: circuitDetails.CircuitId,
                    });
                    this.fetchData(circuitDetails.CircuitId, circuitDetails);
                }

                const { getCircuitEquipList } = this.props;
           
                if (this.state.updateEquipmentListStatus === true && !isNewCircuit) {
                    getCircuitEquipList(circuitId, result.circuitDetails.VendorID);
                }

                this.props.FormLoad('inventoryCircuitForm', inventoryCircuitForm);
           
                this.setState({
                    originalCircuitTypeID: this.props.inventoryCircuitForm.circuitDetails.circuitTypeID,
                    originalVendorID: this.props.inventoryCircuitForm.circuitDetails.vendorID,
                    originalPlanDetails: {
                        "datatable": this.props.inventoryCircuitPlanDetails.planDetails.datatable
                    },
                    updateEquipmentListStatus: false
                });  
                if (!isNewCircuit) {
                    this.setState({ inProgress: true });
                    this.fetchData(this.state.circuitId, this.state.selectedCircuit).then(()=>{
                        this.setState({ inProgress: false });
                    }); 
                }

                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), successMessage);              
            }

            this.toggleSaveModal(false);

            return;
        }
    }

    updateEquipmentListStatus = (item, index, arr) => {
        if (parseInt(arr[index].StatusId) === parseInt(CIRCUIT_STATUS.inService.id)) {
            arr[index].StatusId = parseInt(this.props.inventoryCircuitForm.circuitDetails.statusID);
        }
    }

    handleCloseNotif = () => {
        this.toggleSaveNotif(false);
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("new_circuit_message")) {
            this.CloseForm();
            this.props.getInventoryCircuit();
        }
    }
    handleChangesStatus = (prop, truthValue) =>{
        this.setState({
            [prop]: truthValue
        })
    }
    handleChangesStatusPlan = (prop, truthValue, mrc, planUpdated) => {
        this.props.updateCircuitMRC(mrc);
        this.setState({
            [prop]: truthValue,
            planDetailsUpdated: planUpdated
        })
    }
    disableSaveChanges = () => {
        if (!this.state.inProgress) {
            const {
                inventoryCircuitForm,
                inventoryCircuitSIM,
                inventoryCircuitPlanDetails,
                inventoryCircuitEquip,
                inventoryCostAllocation,
                $form
            } = this.props;

            const { circuitDetails } = inventoryCircuitForm;

            const isFieldEmpty = !circuitDetails.circuitCode
                || !circuitDetails.statusID
                || !circuitDetails.circuitTypeID
                || !circuitDetails.monthlyRateCharge
                || !circuitDetails.primarySecondary
                || !circuitDetails.billingAccountID
                || !circuitDetails.endUserID;

            if (isFieldEmpty) {
                return true;
            }

            const unchangedCircuitDetails = !$form.loadedValue ? true : isObjectEqual($form.loadedValue, inventoryCircuitForm);

            const circuitSimDetails = inventoryCircuitSIM?.circuitSimList?.datatable?.length > 0
                ? areDataEqual(this.state.originalSimData.circuitSimList.datatable[0], inventoryCircuitSIM.circuitSimList.datatable[0])
                : true;

            const circuitPlanDetails = inventoryCircuitPlanDetails?.planDetails?.datatable?.length > 0
                ? areDataEqual(this.state.originalPlanData.planDetails.datatable[0].dataItem, inventoryCircuitPlanDetails.planDetails.datatable[0].dataItem)
                : true;

            const circuitEquipDetails = inventoryCircuitEquip?.circuitEquipList?.datatable?.length > 0
                ? areDataEqual(this.state.originalEquipmentData.circuitEquipList.datatable[0].dataItem, inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem)
                : true;

            const circuitCostAllocationDetails = inventoryCostAllocation?.circuitCostAllocation?.datatable?.length > 0
                ? areDataEqual(this.state.originalCostAllocationData.circuitCostAllocation.datatable[0].dataItem, inventoryCostAllocation.circuitCostAllocation.datatable[0].dataItem)
                : true;

            return unchangedCircuitDetails && circuitSimDetails && circuitPlanDetails && circuitEquipDetails && circuitCostAllocationDetails;
        } else {
            return true;
        }
    };
      

    orderHistoryStatus = () => {
        const { inventoryOrderHistory } = this.props;
        var orderHistory = inventoryOrderHistory.inventoryOrderHistoryItems.Data.Items;

        if (orderHistory != null && orderHistory.length > 0 && orderHistory !== undefined) {
            const filterArray = orderHistory.filter(order => {
                return order.Status.includes(REQUEST_STATUS.inProgress) || order.Status.includes(REQUEST_STATUS.open) || order.Status.includes(REQUEST_STATUS.inProgressAwaitingToVendor)
                || order.Status.includes(REQUEST_STATUS.inProgressSubmittedToVendor)
            });

            if (filterArray.length > 0) {
                this.setState({ pendingApproval: true });
            }
        }

    }
    convertToDecimal = (value) =>{
        if(typeof value === "string") return value;

        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }

    handleGetAccountDetail = (billingAccountID)=>{
        const { getAccountDetailsModal, getAccountCostAllocationModal, getAccountLinkedCircuit } =this.props
        getAccountDetailsModal(billingAccountID)
        getAccountCostAllocationModal(billingAccountID) 
        getAccountLinkedCircuit(billingAccountID)
    }

    handleOnClearOption = () => {
        const { selectLocation, inventoryCircuitForm } = this.props;
        if(inventoryCircuitForm.location1.locationID === "") {
            selectLocation('.location1.locationID', -1)
        }
        if(inventoryCircuitForm.location2.locationID === "") {
            selectLocation('.location2.locationID', -1)
        }
    }

    render() {
        const { inventoryCircuit, inventoryCircuitForm, locale, selectUserHRID, isCreateNew } = this.props
        const { circuitDetails, location1, location2} = inventoryCircuitForm;
        const link_primary_circuit_disabled = (this.state.dropDownFields.billingAccountID ||
            circuitDetails.billingAccountID) &&
            circuitDetails.primarySecondary === CIRCUIT_SIM_RANK.Secondary ? false : true
        const circuitId = this.state.circuitId ?? 0;
        let vendorId = circuitDetails.vendorID ?? 0;
        this.handleOnClearOption();
        if(this.state.loading) {
            return this.loading()
        }
        const initialRequired = circuitDetails.circuitCode === '' || circuitDetails.statusID === 0
            || circuitDetails.circuitTypeID === 0 || circuitDetails.circuitTypeID === ''
            || circuitDetails.billingAccountID === 0 || circuitDetails.billingAccountID === ''
            || circuitDetails.endUserID === 0 || circuitDetails.endUserID === ''
            || circuitDetails.monthlyRateCharge === '' || circuitDetails.primarySecondary === '';

        return (
            <div className="remove-background inventory-internal-table request-table-invoice">               
                <Form method="post" role="form"
                    model="inventoryCircuitForm"
                    onSubmit={this.submitRequest}
                >
                    {
                        this.state.pendingApproval &&
                        <CircuitNotification show={this.state.showConfModal} handleModal={this.handleConfirmationModal} />
                    }
                    <ButtonIcon onClick={this.CloseForm.bind(this)} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                    <ListTabButton listData={this.activeListTabInfo()} selectedIndex={this.props.haveTotalDetail ? this.state.selectedTab : this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)} />
                    {
                        this.state.selectedIndex === Selected_Index.i_Zero &&
                        <div className="inventory-details-field-container">
                            <div className="details-container date-picker-main-container">
                                <div className="details-field-container">
                                    <div className="detail-with-icon-container">
                                            {(this.state.isInService
                                                &&
                                                (this.props.isReadOnly
                                                || this.props.isReadAndExtractOnly
                                                || this.props.isReadAndWrite)
                                             )
                                                &&
                                           <Icon
                                            name="ellipsis"
                                            size="18px"
                                            customClassName="icon-nav"
                                            containerClass="info-container"
                                            onClick={!this.state.takeAction ? this.handleShowTakeAction.bind(this) : null}
                                            />}
                                        <div className={`create-request-children ${this.state.showTakeAction ? 'Active' : ""}`}>
                                            <span>{`${this.toLocaleLanguage('actions_capital')}`}</span>

                                            {this.state.takeActionItem?.map((list, index) =>
                                                <span key={index} className="take-action-list" onClick={() => this.handleTakeActionModal(list.RequestTypeID, list.RequestType)}>{list.RequestType}</span>
                                            )}
                                        </div>

                                        <InputField
                                            className="form-control required"
                                            type="text"
                                            label={`${this.toLocaleLanguage('circuit_id_capital')}`}
                                            value={circuitDetails.circuitCode}
                                            fieldProp='inventoryCircuitForm.circuitDetails.circuitCode'
                                            placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                            maxLength={MAX_LENGTH.limit_100}
                                        />
                                    </div>
                                    <Select
                                        className="form-select required"
                                        label={`${this.toLocaleLanguage('status_capital')}`}
                                        value={circuitDetails.statusID}
                                        options={inventoryCircuit.inventoryAllAccountStatuses}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        fieldProp='inventoryCircuitForm.circuitDetails.statusID'
                                    />
                                   <CustomSearchableSelectWrapper
                                        label={`${this.toLocaleLanguage('circuit_type_capital')}`}
                                        options={inventoryCircuit.inventoryCircuitTypesByCategory}
                                        selected={circuitDetails.circuitTypeID}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        onChange={(e) => this.onChangeCircuitTypeSelection(e)}
                                        requiredField
                                        fieldProp='inventoryCircuitForm.circuitDetails.circuitTypeID'
                                        tagName='circuitTypeID'
                                        optionLabelKey={{
                                            Key: 'Key',
                                            Value: 'Value'
                                            }}
                                        maxLength={MAX_LENGTH.limit_100}
                                    />
                                    
                                    <CustomSearchableSelectWrapper
                                    label={`${this.toLocaleLanguage('sub_circuit_type_capital')}`}
                                    options={inventoryCircuit.inventorySubCircuitTypes}
                                    selected={circuitDetails.subCircuitTypeID}
                                    requiredField={this.props.requiredField}
                                    fieldProp='inventoryCircuitForm.circuitDetails.subCircuitTypeID'
                                    tagName='subCircuitTypeID'
                                    optionLabelKey={{
                                        Key: 'CircuitId',
                                        Value: 'CircuitCode'
                                            }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    maxLength={MAX_LENGTH.limit_100}
                                    />
                                    <InputField
                                            className="form-control required"
                                            type="text"
                                            label={`${this.toLocaleLanguage('mrc')}`}                           
                                            value={this.convertToDecimal(circuitDetails.monthlyRateCharge)}                                           
                                            fieldProp='inventoryCircuitForm.circuitDetails.monthlyRateCharge'
                                            placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                            inputType={DATA_TYPE.decimal}
                                            maxLength={MAX_LENGTH.inputText}/>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('currency_capital')}`}
                                        value={circuitDetails.currency}
                                        fieldProp='inventoryCircuitForm.circuitDetails.currency'
                                        disabled={true}
                                    />
                                    <SelectRanking
                                        className="form-select required"
                                        label={`${this.toLocaleLanguage('circuit_ranking_capital')}`}
                                        value={circuitDetails.primarySecondary}
                                        options={inventoryCircuit.inventoryAllCircuitRankings}
                                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                        fieldProp='inventoryCircuitForm.circuitDetails.primarySecondary'
                                        onChangeAction={this.props.selectCircuitRank}
                                        />

                                    <CustomSearchableSelectWrapper
                                            label={`${this.toLocaleLanguage('link_primary_circuit_capital')}`}
                                            options={inventoryCircuit.linkedCircuitsOptions}
                                            selected={circuitDetails.primarySecondary === CIRCUIT_SIM_RANK.Primary ? null : circuitDetails.linkedCircuitID}
                                            disabled={link_primary_circuit_disabled}
                                            requiredField={this.props.requiredField}
                                            fieldProp='inventoryCircuitForm.circuitDetails.linkedCircuitID'
                                            placeholder={!link_primary_circuit_disabled? this.toLocaleLanguage('select_placeholder') : null}
                                            maxLength={MAX_LENGTH.limit_100}
                                            tagName='linkedCircuitID'
                                            optionLabelKey={{
                                                Key: 'Key',
                                                Value: 'Value'
                                              }}
                                    />
                                    <div className="detail-with-icon-container">
                                            {
                                                circuitDetails.billingAccountID > 0 &&
                                                
                                                <DetailsInfo 
                                                    title="Account Details" 
                                                    linkedTitle="linked_circuits_capital"
                                                    valueselected = {circuitDetails.billingAccountID}
                                                    locale={locale}
                                                    getAccountDetail={this.handleGetAccountDetail}
                                                    routeLocation={ROUTE_LINK_LOCATION.circuitRouteLink}

                                                    //Search
                                                    setSearchValue={this.props.setAccountLinkedCircuitSearchValue}
                                                    searchPlaceHolder={this.toLocaleLanguage('search_circuit')}

                                                    //Cost Allocation
                                                    detailsInfo={inventoryCircuit.inventoryAccountDetails}
                                                    Headers={inventoryCircuit.inventoryAccountCostAllocationModal.Headers}                                                
                                                    costAlloData={inventoryCircuit.inventoryAccountCostAllocationModal.Data}

                                                    //Linked Circuit
                                                    linkedHeaders={inventoryCircuit.inventoryAccountLinkedCircuit.Headers}
                                                    linkedData={inventoryCircuit.inventoryAccountLinkedCircuit.Data}
                                                    linkedPages={inventoryCircuit.inventoryAccountLinkedCircuit.Pagination}
                                                    totalEntries={inventoryCircuit.inventoryAccountLinkedCircuit.Pagination.TotalEntries}
                                                    getAccountLinked={this.props.getAccountLinkedCircuit}
                                                />
                                            } 

                                        <CustomSearchableSelectWrapper
                                            label={`${this.toLocaleLanguage('billing_account_capital')}`}
                                            options={inventoryCircuit.inventoryAllAccountDetails}
                                            selected={circuitDetails.billingAccountID}
                                            onChange={(e) => this.onChangeBillingAccountSelection(e)}
                                            requiredField={true}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            fieldProp='inventoryCircuitForm.circuitDetails.billingAccountID'
                                            tagName='billingAccountID'
                                            maxLength={MAX_LENGTH.limit_100}
                                            optionLabelKey={{
                                                Key: 'BillingAccountID',
                                                Value: 'BillingAccount'
                                              }}
                                            
                                            />
                                    </div>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('account_type_capital')}`}
                                        value={circuitDetails.financeAccountTypeName}
                                        fieldProp='inventoryCircuitForm.circuitDetails.financeAccountTypeName'
                                        disabled={true}
                                    />
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('client_capital')}`}
                                        value={circuitDetails.clientName}
                                        fieldProp='inventoryCircuitForm.circuitDetails.clientName'
                                        disabled={true}
                                    />
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('vendor_capital')}`}
                                        value={circuitDetails.vendor}
                                        fieldProp='inventoryCircuitForm.circuitDetails.vendor'
                                        disabled={true}
                                    />
                                    <div className="detail-with-icon-container">
                                        {
                                            circuitDetails.endUserID > 0 &&
                                            <UserDetailsInfo title="User Details" 
                                                userDetails={inventoryCircuit.inventoryUserHrDetails} 
                                                selectedUser={circuitDetails.endUserID} 
                                                costAllocationData={this.state.dataTable} 
                                                circuitData={this.state.dataTable}
                                                endUserID={circuitDetails.endUserID}
                                                locale = {locale}
                                                    />
                                            }
                                            <CustomSearchableSelectWrapper
                                                label={`${this.toLocaleLanguage('user_hr_id_capital')}`}
                                                options={inventoryCircuit.inventoryAllEmployees}
                                                selected={circuitDetails.endUserID}
                                                onChange={selectUserHRID}
                                                requiredField={true}
                                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                                fieldProp='inventoryCircuitForm.circuitDetails.endUserID'
                                                tagName='circuitDetails.endUserID'                                               
                                                optionLabelKey={{
                                                    Key: 'EmployeeID',
                                                    Value: 'Idhr'
                                                }}
                                                maxLength={MAX_LENGTH.limit_100}                                               
                                            />
                                    </div>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('user_name_capital')}`}
                                        value={circuitDetails.userName}
                                        fieldProp='inventoryCircuitForm.circuitDetails.userName'
                                        disabled={true}
                                    />
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('email_address_capital')}`}
                                        value={circuitDetails.emailAddress}
                                        fieldProp='inventoryCircuitForm.circuitDetails.emailAddress'
                                        disabled={true}
                                    />
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('line_manager_capital')}`}
                                        value={circuitDetails.lineManager}
                                        fieldProp='inventoryCircuitForm.circuitDetails.lineManager'
                                        disabled={true}
                                    />
                                    <DATEPICKER_OR 
                                    dateOnly={true} 
                                    label={`${this.toLocaleLanguage('install_date_capital')}`} 
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`} 
                                    startDate={circuitDetails.installDate} 
                                    selectedDate={(date) => this.props.selectDate("inventoryCircuitForm.circuitDetails.installDate", date)} 
                                    />
                                    <DATEPICKER_OR 
                                    dateOnly={true} 
                                    label={`${this.toLocaleLanguage('disconnect_date_capital')}`} 
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`} 
                                    startDate={circuitDetails.disconnectDate} 
                                    selectedDate={(date) => this.props.selectDate("inventoryCircuitForm.circuitDetails.disconnectDate", date)}
                                     />

                                    <DateRange 
                                    dateOnly={true} 
                                    label={`${this.toLocaleLanguage('suspension_date_capital')}`} 
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`} 
                                    startDate={circuitDetails.suspensionFromDate} 
                                    endDate={circuitDetails.suspensionToDate} 
                                    dateSelected={circuitDetails.suspensionFromDate} 
                                    onChange={this.onChangeDates} />
                                    <DATEPICKER_OR 
                                    dateOnly={true} 
                                    label={`${this.toLocaleLanguage('contract_end_date_capital')}`} 
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`} 
                                    startDate={circuitDetails.contractEndDate} 
                                    selectedDate={(date) => this.props.selectDate("inventoryCircuitForm.circuitDetails.contractEndDate", date)}
                                     />
                                </div>
                                <div className="horizontal-separator"></div>
                                    <CustomDropdown label={`${this.toLocaleLanguage('location_address_1')}`} isActive={this.state.activeDropdown === Selected_Index.i_Zero} onToggle={() => this.handelToggleDropdown(Selected_Index.i_Zero)}>
                                        <div className= "add-sim-container">
                                            <AddressDetails locationDetails={location1} translator={(x) => this.toLocaleLanguage(x)} inventoryAllLocations={inventoryCircuit.inventoryAllLocations} circuitKey="circuitLocationAddress" fieldProp=".location1" formName="inventoryCircuitForm" onChangeAction={this.props.selectLocation} />        
                                        </div>
                                </CustomDropdown>
                                    <CustomDropdown label={`${this.toLocaleLanguage('location_address_2')}`} isActive={this.state.activeDropdown === Selected_Index.i_One} onToggle={() => this.handelToggleDropdown(Selected_Index.i_One)}>
                                        <div className= "add-sim-container">
                                            <AddressDetails locationDetails={location2} translator={(x) => this.toLocaleLanguage(x)} inventoryAllLocations={inventoryCircuit.inventoryAllLocations} circuitKey="circuitLocationP2P" fieldProp=".location2" formName="inventoryCircuitForm" onChangeAction={this.props.selectLocation} />
                                        </div>
                                </CustomDropdown>                               

                                    <AddPlanDetails
                                        //Access Type
                                        isReadOnly={this.props.isReadOnly}
                                        isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                                        isReadAndWrite={this.props.isReadAndWrite}
                                        handleChangesStatus={this.handleChangesStatusPlan}
                                        hasPendingApproval={this.state.pendingApproval}
                                        circuitId={circuitId}
                                        planId={this.state.planId}
                                        vendorId={vendorId}
                                        circuitTypeId={circuitDetails.circuitTypeID}
                                        isTogglePlan={this.state.isTogglePlan}
                                        isOriginalComponent={this.state.isOriginalComponent}
                                    />

                                    <AddSim 
                                        circuitId={circuitId} 
                                        toggleDropdown={this.handelToggleDropdown} 
                                        activeDropdown={this.state.activeDropdown}                                       
                                        //Access Type
                                        isReadOnly={this.props.isReadOnly}
                                        isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                                        isReadAndWrite={this.props.isReadAndWrite}
                                        translator={(x) => this.toLocaleLanguage(x)}
                                        handleChangesStatus={this.handleChangesStatus}
                                        hasPendingApproval={this.state.pendingApproval}
                                    />

                                    <AddEquipment 
                                        circuitId={circuitId} 
                                        toggleDropdown={this.handelToggleDropdown} 
                                        activeDropdown={this.state.activeDropdown} 
                                        statusValue={circuitDetails.statusID}
                                        //Access Type
                                        isReadOnly={this.props.isReadOnly}
                                        isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                                        isReadAndWrite={this.props.isReadAndWrite}
                                        translator={(x) => this.toLocaleLanguage(x)}
                                        handleChangesStatus={this.handleChangesStatus}
                                        hasPendingApproval={this.state.pendingApproval}
                                        vendorId = {vendorId}
                                    />

                                    <Errors model="inventoryCircuitForm.circuitCostAllocations" className="has-error" />
                                    <div className="control-container">                                      
                                         <AddCostAllocation
                                                circuitId={circuitId}
                                                titleBtn={this.state.updateCostAllocationDetails ? ACTION_TYPES.Update : ACTION_TYPES.Add}
                                                showDetails={this.ShowCostAllocationDetails.bind(this)}
                                                toggleDropdown={this.handelToggleDropdown}
                                                activeDropdown={this.state.activeDropdown}
                                                toggleActiveState={this.toggleActiveState}
                                                inventoryCircuit={inventoryCircuit}
                                                glcodeOptions={inventoryCircuit.circuitGlCodeList}
                                                costcenterOptions={inventoryCircuit.circuitCostCenterList}
                                                //Access Type
                                                isReadOnly={this.props.isReadOnly}
                                                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                                                isReadAndWrite={this.props.isReadAndWrite}
                                                translator={(x) => this.toLocaleLanguage(x)}
                                                handleChangesStatus={this.handleChangesStatus}
                                                hasPendingApproval={this.state.pendingApproval}
                                            />
                                    </div>
                            </div>
                            {
                                this.state.pendingApproval ?
                                    <span className="pending-approval-message">Note: This circuit is still under an order workflow, users are restricted to save any changes</span>
                                    :
                                        <div className="save-btn-container">

                                            <ConfirmationModal
                                                ref={this.ConfirmationModal}
                                                title={this.state.saveModal.title}
                                                messageBody={this.state.saveModal.messageBody}
                                                confirmAction={this.state.saveModal.confirmAction}
                                                closeLabel={this.toLocaleLanguage("cancel_button")}
                                                confirmLabel={this.toLocaleLanguage("yes_button")}
                                                disabled={this.state.isSaving}
                                                isUpdate={this.state.saveModal.title.toLowerCase()==="update" && true}
                                            />
                                             
                                            <NotificationModal
                                                show={this.state.saveNotif.show}
                                                title={this.state.saveNotif.title}
                                                message={this.state.saveNotif.message}
                                                handleModal={this.handleCloseNotif}
                                                customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                            />
                                            <div className="tooltip-container">
                                                <div className="btn-tooltiptext">
                                                    {this.props.isReadAndWrite &&
                                                        <Button disabled={isCreateNew ? initialRequired : (!this.state.inProgress ? this.disableSaveChanges(): this.state.inProgress)} onClick={() => this.handleSaveCircuitDetails()} className="save-details-btn">
                                                            Save Changes
                                                        </Button>
                                                    }
                                                    <div className="save-tooltip-text-container">
                                                        <span className="tooltip-text-save">{<Translation translationKey="save_changes_on_the_circuit" />}</span>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                            }

                        </div>
                    }
                    {
                        this.state.selectedIndex === Selected_Index.i_One &&
                        <UsageSpend
                            circuitId={circuitId}
                            circuitCode={circuitDetails.circuitCode}
                            financeAccountId={circuitDetails.billingAccountID}
                            //Access Type
                            isReadOnly={this.props.isReadOnly}
                            isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                            isReadAndWrite={this.props.isReadAndWrite}
                        />
                    }
                    {
                        this.state.selectedIndex === Selected_Index.i_Two &&
                        <LinkedCircuit circuitId={circuitId} />

                    }

                    {
                        this.state.selectedIndex=== Selected_Index.i_Three &&
                        <InvoiceCircuit pages={this.state.pages} circuitId={circuitId} financeAccountId={circuitDetails.billingAccountID}
                            //Access Type
                            isReadOnly={this.props.isReadOnly}
                            isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                            isReadAndWrite={this.props.isReadAndWrite}
                        />
                    }

                    {
                        this.state.selectedIndex === Selected_Index.i_Four &&
                        <CircuitComment circuitId={circuitId}
                            //Access Type
                            isReadOnly={this.props.isReadOnly}
                            isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                            isReadAndWrite={this.props.isReadAndWrite}
                        />
                    }
                    {
                        this.state.selectedIndex === Selected_Index.i_Five &&
                        <DetailsHistory listHistoryTab={this.state.historyTabInfo.Tab}
                            circuitPages={this.state.pages}
                            circuitId={circuitId}
                            orderPages={this.state.pages}
                            havePagination={true}
                            //Access Type
                            isReadOnly={this.props.isReadOnly}
                            isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                            isReadAndWrite={this.props.isReadAndWrite}

                            handelOrderHistorySelected={this.handelOrderHistorySelected.bind(this)}
                        />

                    }
                    {this.props.children}
                </Form>
            </div>
        )
    }
};

export default withRouter(
    connect(
        state => {
            const { inventoryCircuit, translation, sideNavMenu, circuitUsage, createRequest, inventoryUserHrDetails, inventoryCircuitPlanDetails, inventoryOrderHistory, inventoryCircuitEquip, inventoryCircuitSIM, inventoryCostAllocation } = state;
            const { inventoryCircuitForm, inventoryUserDetails, forms: { inventoryCircuitForm: { $form } } } = state.form;
            return {
                inventoryCircuitForm
                , inventoryCircuit
                , inventoryUserDetails
                , inventoryUserHrDetails
                , inventoryCircuitPlanDetails
                , inventoryOrderHistory
                , inventoryCostAllocation
                , inventoryCircuitEquip
                , inventoryCircuitSIM
                , ...translation
                , ...sideNavMenu
                , ...circuitUsage
                , ...createRequest
                , $form
            };
        },
        dispatch => ({
            ...bindActionCreators(
                Object.assign({}
                    , inventoryCircuitActions
                    , sideNavMenuActions
                    , createRequestActions
                    , circuitUsageActions
                    , inventoryCostAllocationActions
                    , accessInformationActions
                    , pipInformationActions
                    , addPlanDetailActions
                    , inventoryOrderHistoryActions
                    , inventoryCircuitSimActions
                    , inventoryCircuitEquipActions),

            dispatch
            ),
            FormChange: (Model, value) => {
                dispatch(actions.change(Model, value))
            },
            FormLoad: (model, data) => {
                dispatch(actions.load(model, data));
            }
        })
    )(InventoryDetails)
);
